// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"H7-z"};